export default "__VITE_ASSET__DQ5xMg_a__"